export const clearLocalStorageOnce = () => {
  const SESSION_MARKER = "tab_session_marker";
  const LAST_SEEN_KEY = "app_last_seen";
  const TIMEOUT = 10000;

  const now = Date.now();

  // Never wipe localStorage on the OAuth callback page. Safari clears
  // sessionStorage when returning from a cross-origin navigation, so
  // SESSION_MARKER can be absent here even for the same tab — and the
  // code/verifier pair still needs to survive this transient page load.
  const isOAuthCallback =
    window.location.search.includes("code=") ||
    window.location.hash.includes("code=");

  // clear only once per tab, but always re-start heartbeat on mount/reload
  const alreadyInitialized = sessionStorage.getItem(SESSION_MARKER);

  if (!alreadyInitialized) {
    sessionStorage.setItem(SESSION_MARKER, "true");

    const lastSeen = Number(localStorage.getItem(LAST_SEEN_KEY) || "0");
    const isNewSession = now - lastSeen > TIMEOUT;

    if (isNewSession && !isOAuthCallback) {
      localStorage.clear();
    }
  }

  // heartbeat (while tab is open)
  const interval = setInterval(() => {
    localStorage.setItem(LAST_SEEN_KEY, String(Date.now()));
  }, TIMEOUT);

  localStorage.setItem(LAST_SEEN_KEY, String(now));

  return () => clearInterval(interval);
};
